var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowUp = function SvgArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.561523 5.66113C0.756836 5.85645 1.0498 5.83691 1.24512 5.66113L3.49121 3.29785L3.49121 8.90332C3.49121 9.17676 3.68652 9.37207 3.95996 9.37207H4.58496C4.83887 9.37207 5.05371 9.17676 5.05371 8.90332L5.05371 3.29785L7.28027 5.6416C7.47559 5.83691 7.76855 5.83691 7.96387 5.66113L8.39355 5.23145C8.56934 5.03613 8.56934 4.74316 8.39355 4.56738L4.58496 0.758789C4.40918 0.583008 4.11621 0.583008 3.94043 0.758789L0.131836 4.56738C-0.0439453 4.74316 -0.0439453 5.03613 0.131836 5.23145L0.561523 5.66113Z",
    fill: "#303A5F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowUp.2eb31862.svg";
export { ForwardRef as ReactComponent };